import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { path } from 'ramda'

const editorStyle = (prop, props) => path(['editorStyles', prop], props)

export const EditorWrap = styled.div(
  (props) => `
  border-right: 1px solid ${themeColor('navBorderBottomColor', props)};
  border-bottom: 1px solid ${themeColor('navBorderBottomColor', props)};
  border-left: 1px solid ${themeColor('navBorderBottomColor', props)};
  width: 100%;
  max-width: 1320px;

  .rdw-editor-main {
    height: ${editorStyle('height', props)};
    padding: ${editorStyle('padding', props)};
    overflow: ${editorStyle('overflow', props)};
    font-size: ${editorStyle('fontSize', props)};
    line-height: ${editorStyle('lineHeight', props)};
    font-family: Arial;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;

    ${editorStyle('extra', props)}
  }

  li[class*='depth1'] {
    margin-left: 32px;
  }

  li[class*='depth2'] {
    margin-left: 50px;
  }
`
)
